export class AppConfig {
    logo: string;
    grupo: string;
    subGrupo: string;
    mostrarEstado: boolean;
    tipoUnidad: number;
    loginLogo: string;
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/appConfig.ts